module.exports = __webpack_public_path__ + "static/index/img/baikal-505.4b603dff.jpg";